import { defineStore } from "pinia";
import { useGetData } from "~/composables/useGetData";

export const useSquadreStore = defineStore("squadreStore", {
  state: () => ({
    squadre: [],
    caricandoSquadre: false,
    errorMessage: ""
  }),
  actions: {
    async getSquadreOdoo() {
      const { data, getData, loading, messageError } = useGetData();
      this.caricandoSquadre = true;
      await getData("/api/squadre");
      if (!messageError.value) {
        this.squadre = data.value;
        this.caricandoSquadre = loading.value;
      } else {
        this.errorMessage = messageError;
      }
    }
  }
});
